import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import feedbackEn from './locales/en/feedback.json';
import glossaryEn from './locales/en/glossary.json';
import healthMetricsEn from './locales/en/healthMetrics.json';
import imagingEn from './locales/en/imaging.json';
import labsEn from './locales/en/labs.json';
import visitNotesEn from './locales/en/visitNotes.json';
import healthQuestionsEn from './locales/en/healthQuestions.json';
import symptomTrackerEn from './locales/en/symptomTracker.json';
import medicationInfoEn from './locales/en/medicationInfo.json';
import healthRecordsEn from './locales/en/healthRecords.json';
import aiAdvisorEn from './locales/en/aiAdvisor.json';
import insuranceGuideEn from './locales/en/insuranceGuide.json';
import exerciseTrackerEn from './locales/en/exerciseTracker.json';

// Spanish translations
import commonEs from './locales/es/common.json';
import authEs from './locales/es/auth.json';
import feedbackEs from './locales/es/feedback.json';
import glossaryEs from './locales/es/glossary.json';
import healthMetricsEs from './locales/es/healthMetrics.json';
import imagingEs from './locales/es/imaging.json';
import labsEs from './locales/es/labs.json';
import visitNotesEs from './locales/es/visitNotes.json';
import healthQuestionsEs from './locales/es/healthQuestions.json';
import symptomTrackerEs from './locales/es/symptomTracker.json';
import medicationInfoEs from './locales/es/medicationInfo.json';
import healthRecordsEs from './locales/es/healthRecords.json';
import aiAdvisorEs from './locales/es/aiAdvisor.json';
import insuranceGuideEs from './locales/es/insuranceGuide.json';
import exerciseTrackerEs from './locales/es/exerciseTracker.json';

// French translations
import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import feedbackFr from './locales/fr/feedback.json';
import glossaryFr from './locales/fr/glossary.json';
import healthMetricsFr from './locales/fr/healthMetrics.json';
import imagingFr from './locales/fr/imaging.json';
import labsFr from './locales/fr/labs.json';
import visitNotesFr from './locales/fr/visitNotes.json';
import healthQuestionsFr from './locales/fr/healthQuestions.json';
import symptomTrackerFr from './locales/fr/symptomTracker.json';
import medicationInfoFr from './locales/fr/medicationInfo.json';
import healthRecordsFr from './locales/fr/healthRecords.json';
import aiAdvisorFr from './locales/fr/aiAdvisor.json';
import insuranceGuideFr from './locales/fr/insuranceGuide.json';
import exerciseTrackerFr from './locales/fr/exerciseTracker.json';

// German translations
import commonDe from './locales/de/common.json';
import authDe from './locales/de/auth.json';
import feedbackDe from './locales/de/feedback.json';
import glossaryDe from './locales/de/glossary.json';
import healthMetricsDe from './locales/de/healthMetrics.json';
import imagingDe from './locales/de/imaging.json';
import labsDe from './locales/de/labs.json';
import visitNotesDe from './locales/de/visitNotes.json';
import healthQuestionsDe from './locales/de/healthQuestions.json';
import symptomTrackerDe from './locales/de/symptomTracker.json';
import medicationInfoDe from './locales/de/medicationInfo.json';
import healthRecordsDe from './locales/de/healthRecords.json';
import aiAdvisorDe from './locales/de/aiAdvisor.json';
import insuranceGuideDe from './locales/de/insuranceGuide.json';
import exerciseTrackerDe from './locales/de/exerciseTracker.json';

// Italian translations
import commonIt from './locales/it/common.json';
import authIt from './locales/it/auth.json';
import feedbackIt from './locales/it/feedback.json';
import glossaryIt from './locales/it/glossary.json';
import healthMetricsIt from './locales/it/healthMetrics.json';
import imagingIt from './locales/it/imaging.json';
import labsIt from './locales/it/labs.json';
import visitNotesIt from './locales/it/visitNotes.json';
import healthQuestionsIt from './locales/it/healthQuestions.json';
import symptomTrackerIt from './locales/it/symptomTracker.json';
import medicationInfoIt from './locales/it/medicationInfo.json';
import healthRecordsIt from './locales/it/healthRecords.json';
import aiAdvisorIt from './locales/it/aiAdvisor.json';
import insuranceGuideIt from './locales/it/insuranceGuide.json';
import exerciseTrackerIt from './locales/it/exerciseTracker.json';

const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    feedback: feedbackEn,
    glossary: glossaryEn,
    healthMetrics: healthMetricsEn,
    imaging: imagingEn,
    labs: labsEn,
    visitNotes: visitNotesEn,
    healthQuestions: healthQuestionsEn,
    symptomTracker: symptomTrackerEn,
    medicationInfo: medicationInfoEn,
    healthRecords: healthRecordsEn,
    aiAdvisor: aiAdvisorEn,
    insuranceGuide: insuranceGuideEn,
    exerciseTracker: exerciseTrackerEn,
  },
  es: {
    common: commonEs,
    auth: authEs,
    feedback: feedbackEs,
    glossary: glossaryEs,
    healthMetrics: healthMetricsEs,
    imaging: imagingEs,
    labs: labsEs,
    visitNotes: visitNotesEs,
    healthQuestions: healthQuestionsEs,
    symptomTracker: symptomTrackerEs,
    medicationInfo: medicationInfoEs,
    healthRecords: healthRecordsEs,
    aiAdvisor: aiAdvisorEs,
    insuranceGuide: insuranceGuideEs,
    exerciseTracker: exerciseTrackerEs,
  },
  fr: {
    common: commonFr,
    auth: authFr,
    feedback: feedbackFr,
    glossary: glossaryFr,
    healthMetrics: healthMetricsFr,
    imaging: imagingFr,
    labs: labsFr,
    visitNotes: visitNotesFr,
    healthQuestions: healthQuestionsFr,
    symptomTracker: symptomTrackerFr,
    medicationInfo: medicationInfoFr,
    healthRecords: healthRecordsFr,
    aiAdvisor: aiAdvisorFr,
    insuranceGuide: insuranceGuideFr,
    exerciseTracker: exerciseTrackerFr,
  },
  de: {
    common: commonDe,
    auth: authDe,
    feedback: feedbackDe,
    glossary: glossaryDe,
    healthMetrics: healthMetricsDe,
    imaging: imagingDe,
    labs: labsDe,
    visitNotes: visitNotesDe,
    healthQuestions: healthQuestionsDe,
    symptomTracker: symptomTrackerDe,
    medicationInfo: medicationInfoDe,
    healthRecords: healthRecordsDe,
    aiAdvisor: aiAdvisorDe,
    insuranceGuide: insuranceGuideDe,
    exerciseTracker: exerciseTrackerDe,
  },
  it: {
    common: commonIt,
    auth: authIt,
    feedback: feedbackIt,
    glossary: glossaryIt,
    healthMetrics: healthMetricsIt,
    imaging: imagingIt,
    labs: labsIt,
    visitNotes: visitNotesIt,
    healthQuestions: healthQuestionsIt,
    symptomTracker: symptomTrackerIt,
    medicationInfo: medicationInfoIt,
    healthRecords: healthRecordsIt,
    aiAdvisor: aiAdvisorIt,
    insuranceGuide: insuranceGuideIt,
    exerciseTracker: exerciseTrackerIt,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'feedback', 'glossary', 'healthMetrics', 'imaging', 'labs', 'visitNotes', 'healthQuestions', 'symptomTracker', 'medicationInfo', 'healthRecords', 'aiAdvisor', 'insuranceGuide', 'exerciseTracker'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
